import ExpandedRteTrigger from './ExpandedRteTrigger';

const els = document.querySelectorAll('.js-expanded-rte');

for (let el of els) {
    new ExpandedRteTrigger(el);
}
